import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Hearts } from 'react-loader-spinner';

// Route guard that requires the user to be authenticated and email-verified
// Email verification is only enforced for password (email/password) accounts.
const VerifiedRoute = ({ children }) => {
    const [state, setState] = useState({ loading: true, canAccess: false });
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (!user) {
                setState({ loading: false, canAccess: false });
                return;
            }

            // Determine provider; if Google, allow without email verification
            const providers = user.providerData || [];
            const isGoogle = providers.some((p) => p.providerId === 'google.com');
            const isPassword = providers.some((p) => p.providerId === 'password');

            if (isGoogle) {
                setState({ loading: false, canAccess: true });
                return;
            }

            if (isPassword) {
                // Ensure latest verification status
                try {
                    await user.reload();
                } catch (e) {
                    // ignore reload errors; fall back to current state
                }
                setState({ loading: false, canAccess: !!user.emailVerified });
                return;
            }

            // Default: allow if verified, otherwise block
            setState({ loading: false, canAccess: !!user.emailVerified });
        });

        return () => unsubscribe();
    }, [auth]);

    if (state.loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Hearts height="80" width="80" color="#f97316" ariaLabel="hearts-loading" visible={true} /></div>;
    }

    if (!state.canAccess) {
        return <Navigate to="/verify-email" />;
    }

    return children;
};

export default VerifiedRoute;
